(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zp-reviews"] && !Shopify.designMode) return;
  try {
    
function initializeZpReviews(scope) {
  scope.querySelectorAll('[data-zp-reviews]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('.zp-reviews__track');
    const cards = Array.from(track.children);
    for (let i = cards.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [cards[i], cards[j]] = [cards[j], cards[i]]; }
    cards.forEach(card => track.append(card));
    const limit = Number(root.dataset.reviewLimit || 6);
    cards.slice(limit).forEach(card => card.remove());
    const move = direction => track.scrollBy({ left: direction * (cards[0].getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    root.querySelector('[data-review-prev]').addEventListener('click', () => move(-1));
    root.querySelector('[data-review-next]').addEventListener('click', () => move(1));
    track.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); } });
  });
}
initializeZpReviews(document);
document.addEventListener('shopify:section:load', event => initializeZpReviews(event.target));

  } catch(e) { console.error(e); }
})();
})();
